//Reset data
export const RESET = "CARACTERISATION_CREATE_RESET"

//Loading
export const SET_TOGGLE_LOADING = "CARACTERISATION_CREATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CARACTERISATION_CREATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CARACTERISATION_CREATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "CARACTERISATION_CREATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "CARACTERISATION_CREATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CARACTERISATION_CREATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CARACTERISATION_CREATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CARACTERISATION_CREATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CARACTERISATION_CREATE_SET_HIDE_MESSAGE"

//Data
export const SET_CREATED = "CARACTERISATION_CREATE_SET_CREATED"
export const SET_IS_CREATED = "CARACTERISATION_CREATE_SET_IS_CREATED"
export const SET_NOT_CREATED = "CARACTERISATION_CREATE_SET_NOT_CREATED"
export const SET_CURRENT_ITEM = "CARACTERISATION_CREATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "CARACTERISATION_CREATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "CARACTERISATION_CREATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "CARACTERISATION_CREATE_SET_HIDE_MODAL"


export const SET_MODAL = "CARACTERISATION_CREATE_SET_MODAL"
export const SET_MODAL_CONTENT = "CARACTERISATION_CREATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "CARACTERISATION_CREATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "CARACTERISATION_CREATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "CARACTERISATION_CREATE_SET_MODAL_TYPE"